import React, { useState } from "react";
import styled from "styled-components";
import Toggle from "../../../../core/components/CollapsToggle/Toggle";
import TextTemplateTable from "./TextTemplateTable";
import TemplateGeneratory from "./TemplateGeneratory";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";

function TextTemplate() {
  const [refresh, setRefresh] = useState(false);

  return (
    <>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="دسته بندی محصولات"
        num3="افزودن جدول کلمات"
        href1="/dashboard/content-controller"
        href2="/dashboard/productCategory"
      />
      <TextTempalteStyle>
        <Toggle title={"افزودن جدول کلمات"}>
          <TemplateGeneratory refresh={refresh} setRefresh={setRefresh} />
        </Toggle>
        <TextTemplateTable refresh={refresh} setRefresh={setRefresh} />
      </TextTempalteStyle>
    </>
  );
}

const TextTempalteStyle = styled.div``;

export default TextTemplate;
